var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSystemUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    viewBox: "0 96 960 960",
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M298.461 976q-24.577 0-41.519-16.942Q240 942.116 240 917.539V234.461q0-24.577 16.942-41.519Q273.884 176 298.461 176h363.078q24.577 0 41.519 16.942Q720 209.884 720 234.461v683.078q0 24.577-16.942 41.519Q686.116 976 661.539 976H298.461Zm-24.615-90.769v32.308q0 9.231 7.692 16.923 7.692 7.692 16.923 7.692h363.078q9.231 0 16.923-7.692 7.692-7.692 7.692-16.923v-32.308H273.846Zm0-33.846h412.308v-550.77H273.846v550.77ZM480 709.128 349.487 578.103l24.256-24.257 89.334 89.693V447.59h33.846v195.949l89.333-89.693 24.77 24.257L480 709.128ZM273.846 266.769h412.308v-32.308q0-9.231-7.692-16.923-7.692-7.692-16.923-7.692H298.461q-9.231 0-16.923 7.692-7.692 7.692-7.692 16.923v32.308Zm0 0V209.846v56.923Zm0 618.462V942.154v-56.923Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemUpdate);
export default __webpack_public_path__ + "static/media/system-update.1402bf9f251b975a9e4c4d65cd00ecf4.svg";
export { ForwardRef as ReactComponent };